import cookie from 'cookie'
import assign from 'lodash/assign'

const defaultOptions = {
    path: '/'
};

/**
 * Returns value stored in cookie. If cookie does not exists, undefined is returned.
 * @param name
 */
function getCookie(name) {
    const cookies = cookie.parse(document.cookie);
    return cookies[name];
}

/**
 * Set cookie value.
 * @param name
 * @param value
 * @param options
 */
function setCookie(name, value, options) {
    const opts = assign({}, defaultOptions, options);
    document.cookie = cookie.serialize(name, value, opts);
}

export default {
    getCookie,
    setCookie,
    defaultOptions
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/cookie.js